import { Outlet } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import SidebarClient from "../SideBar/SideBarClient";
import "./Layout.css";
import { Suspense } from "react";
import LoadingOverlay from "../Custom/LoadingOverlay";
import MenuPopup from "./MenuPopup";
import useGroupMessaging from "../../customHooks/globalCustomHooks/useGroupMessaging";
import useOneOnOneMessaging from "../../customHooks/globalCustomHooks/useOneOnOneMessaging";
import useFetchUnreadMsgChatRoomsCount from "../../customHooks/globalCustomHooks/useFetchUnreadMsgChatRoomsCount";
import LoginFeedbackModal from "../../pages/event-details/components/feedback/LoginFeedbackModal";
import { useState } from "react";
import useNoteOneOnOneMessagingEvents from "../../customHooks/socketEvents/noteOneOnOneMessaging/useNoteOneOnOneMessagingEvents";
import { useSelector } from "react-redux";
import { ContractorConsent } from "./_components/ContractorConsent";
import { ServiceAgreementGate } from "./_components/ServiceAgreementGate";
import { isUserRole, isActiveRole } from "../../utils/methods/storeFunc";
import { USER_ROLES } from "../../staticData/userRoles";
import useNoteOneOnOneSetupEvents from "../../customHooks/socketEvents/noteOneOnOneMessaging/useNoteOneOnOneSetupEvents";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";

const LayoutClient = () => {
  const [toggleSideBarData, setToggleSideBarData] = useState({
    open: true,
    priorityOpen: false,
  });
  const { eventInfo, eventNotesAssignUser } = useSelector(
    (state) => state.eventRequestDetails
  );

  const auth = useSelector((store) => store.auth);

  // custom hooks start...
  // group messaging custom hooks...
  useGroupMessaging();
  // group messaging custom hooks...

  // oneOnOne messaging custom hooks...
  useOneOnOneMessaging();
  // oneOnOne messaging custom hooks...

  // fetchUnreadMsgChatRoomsCount hooks...
  useFetchUnreadMsgChatRoomsCount();
  // fetchUnreadMsgChatRoomsCount hooks...

  // note socket event listener custom hook...
  useNoteOneOnOneMessagingEvents({
    roomIds: eventNotesAssignUser?.[0]?.chatId
      ? [eventNotesAssignUser?.[0]?.chatId]
      : [""],
    eventInfo,
  });

  useNoteOneOnOneSetupEvents();
  // note socket event listener custom hook...
  // custom hooks end...

  const [showFeedbackLayout, setShowFeedbackLayout] = useState(false);

  return (
    <>
      {isActiveRole(USER_ROLES.CLIENT) &&
      (!auth?.termsAcceptedAt || !auth?.smsPermissionStatus) ? (
        <ContractorConsent />
      ) : (
        <Box sx={{}}>
          {/* <NavBarClient /> */}

          {!auth?.isApproved ? (
            <Box
              sx={{
                zIndex: "2",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  border: `2px solid ${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })}`,
                  textAlign: "center",
                  width: "50%",
                  "@media (max-width: 640px)": {
                    width: "90%",
                  },
                  "@media (max-width: 900px)": {
                    width: "75%",
                  },
                  padding: "0.5rem",
                  borderRadius: "0.7rem",
                }}
              >
                {!auth?.isApproved ? (
                  <Typography>
                    We're delighted to have you with us at ShowPhaze. Your
                    profile is under review. For support, feel free to reach out
                    at{" "}
                    <a
                      href="mailto:support@showphaze.com"
                      className="email-link"
                    >
                      support@showphaze.com
                    </a>
                    .
                  </Typography>
                ) : null}
              </Box>
            </Box>
          ) : null}

          <Box
            sx={{
              padding: "40px",
              display: "flex",
              gap: "16px",
              alignItems: "flex-start",
              "@media (max-width: 1200px)": {
                flexDirection: "column",
                paddingTop: "20px",
                "& > div:first-of-type": {
                  display: "none",
                },
              },
              "@media (max-width: 600px)": {
                padding: "15px",
              },
            }}
          >
            <SidebarClient
              toggleSideBarData={toggleSideBarData}
              setToggleSideBarData={setToggleSideBarData}
            />
            <MenuPopup>
              <SidebarClient />
            </MenuPopup>
            <Box
              data-route-scroll-root
              onClick={(e) => {
                // e.stopPropagation();
                if (!toggleSideBarData.priorityOpen) {
                  setToggleSideBarData({ ...toggleSideBarData, open: false });
                }
              }}
              sx={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                flex: "1",
                width: "100%",
                borderRadius: "16px",
                padding: "0",
                border: "2px solid #D175B6",
                background: "rgba(0, 0, 0, 0.50)",
                // background: "red",
                minHeight: "calc(100vh - 204px)",
                // minWidth: "calc(100vw - 396px)",
                overflow: "scroll",
                "&::-webkit-scrollbar": {
                  width: 0, // Hide scrollbar on WebKit browsers (e.g., Chrome, Safari)
                },
                scrollbarWidth: "none", // Hide scrollbar on Firefox
              }}
            >
              <Suspense fallback={<LoadingOverlay open={true} />}>
                {/* Service Agreement banner (finance item 10) — shown until the company signs. */}
                <ServiceAgreementGate />
                <Outlet />
              </Suspense>
            </Box>
          </Box>
          <LoginFeedbackModal
            open={showFeedbackLayout}
            handleClose={() => {
              setShowFeedbackLayout(false);
            }}
            setShowFeedbackLayout={setShowFeedbackLayout}
          />
        </Box>
      )}
    </>
  );
};

export default LayoutClient;

LayoutClient.propTypes = {
  children: PropTypes.node,
};
